/* GFS search: instant dropdown with our own catalog index.
   The index comes from /collections/all?view=gfsindex (templates/collection.gfsindex.liquid)
   and is cached in localStorage, so style numbers like "5000" match 5000, 5000L, 5000B and 5000T. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SEARCH = ROOT + 'search';
  var KEY = 'gfs_idx_v2', TTL = 6 * 3600 * 1000, RECENT = 'gfs_recent';
  var idx = null, loading = null;

  var CATS = { 't-shirts': 'T-shirts & sweatshirts', polos: 'Polos & business', hoodies: 'Hoodies', jackets: 'Jackets', 'caps-hats': 'Caps & hats', ladies: 'Ladies', 'promo-products': 'Promo products', uniforms: 'Uniforms & workwear', scrubs: 'Scrubs', 'premium-brands': 'Premium brands' };
  var POPULAR = ['gildan-5000-unisex-heavy-cotton-t-shirt', 'bella-canvas-3001-jersey-tee', 'gildan-18500-unisex-heavy-blend-hooded-sweatshirt', 'port-authority-k500-silk-touch-polo', 'gildan-18000-unisex-heavy-blend-crewneck-sweatshirt', 'richardson-112-snapback-trucker-cap', 'sport-tek-st350-posicharge-competitor-tee', 'port-and-co-pc78h-core-fleece-pullover-hooded-sweatshirt', 'gildan-5000l-women-s-heavy-cotton-t-shirt', 'comfort-colors-1717-unisex-garment-dyed-heavyweight-t-shirt'];
  var IDEAS = ['5000', '18500 hoodie', 'Bella Canvas 3001', 'Polos', 'Youth tees', 'Trucker caps', 'Comfort Colors', 'Ladies v-neck'];
  var PAGES = [
    ['Rush orders', 'pages/rush-orders', 'rush fast quick 2 day two day same week urgent'],
    ['Request a quote', 'pages/request-a-quote', 'quote price estimate bulk cost'],
    ['Group orders', 'pages/group-orders', 'group team link everyone sizes'],
    ['Fundraiser stores', 'pages/fundraisers', 'fundraiser store school booster'],
    ['DTF printing', 'pages/dtf-printing', 'dtf print printing transfer full color'],
    ['Embroidery', 'pages/embroidery', 'embroidery embroidered stitch logo'],
    ['Laser engraving', 'pages/laser-engraving', 'laser engrave engraving tumbler plaque'],
    ['Bring my own items', 'pages/bring-my-own-items', 'own items customer supplied bring'],
    ['Order status', 'pages/order-status', 'order status track tracking where'],
    ['Business accounts', 'pages/business-accounts', 'business account tax exempt net terms']
  ];
  /* Word families: any of these counts as a match for the typed word. */
  var SYN = {};
  [
    ['hoodie', 'hoodies', 'hoody', 'hooded', 'hood'],
    ['sweatshirt', 'sweatshirts', 'sweater', 'fleece', 'crewneck', 'crew'],
    ['tee', 'tees', 'tshirt', 'tshirts', 'shirt', 'shirts'],
    ['ladies', 'lady', 'women', 'womens', 'woman', 'female', 'junior', 'juniors'],
    ['girls', 'girl'],
    ['kids', 'kid', 'children', 'child', 'youth', 'boys', 'boy'],
    ['baby', 'babies', 'infant', 'toddler', 'onesie', 'bodysuit', 'newborn'],
    ['hat', 'hats', 'cap', 'caps', 'trucker', 'snapback'],
    ['beanie', 'beanies', 'knit'],
    ['polo', 'polos'],
    ['jacket', 'jackets', 'coat', 'windbreaker', 'vest', 'outerwear'],
    ['tank', 'tanks', 'sleeveless'],
    ['performance', 'drifit', 'dri', 'dry', 'wicking', 'moisture', 'posicharge', 'cooling', 'cool'],
    ['sweatpants', 'jogger', 'joggers', 'pants'],
    ['longsleeve', 'long'],
    ['mens', 'men', 'man', 'male', 'unisex']
  ].forEach(function (fam) { fam.forEach(function (w) { SYN[w] = fam; }); });
  /* Old Gildan catalog codes customers still type. */
  var CODES = { g500: '5000', g200: '2000', g180: '18000', g185: '18500', g640: '64000', g800: '8000', g240: '2400', g120: '12000', g125: '12500', g540: '5400', g880: '8800', g420: '42000' };

  function norm(s) { return String(s || '').toLowerCase().replace(/[™®©’']/g, '').replace(/&/g, ' and ').replace(/\+/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function img(p, w) { return p.img ? ROOT.replace(/\/$/, '') + '/cdn/shop/' + p.img.replace(/width=\d+/, 'width=' + (w || 240)) : ''; }
  function track(n, d) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: n }, d || {})); } catch (e) {} }

  function prep(rows) {
    return rows.map(function (r) {
      var p = { h: r[0], t: r[1], v: r[2], ty: r[3], st: String(r[4] || ''), g: r[5], img: r[6], p: r[7], nc: r[8], cats: r[9] ? r[9].split(' ') : [] };
      p.stl = p.st.toLowerCase();
      p.vn = norm(p.v);
      /* color families come plural ("blacks greys"), so add the singular and "gray" too */
      var fam = String(r[10] || '').split(' ').filter(Boolean);
      var cols = fam.concat(fam.map(function (f) { return f.replace(/s$/, ''); }), fam.indexOf('greys') >= 0 ? ['gray', 'heather'] : []);
      p.words = norm(p.t + ' ' + p.ty + ' ' + p.g + ' ' + p.cats.join(' ').replace(/-/g, ' ')).split(' ').concat(cols);
      p.name = p.t.indexOf(' - ') > 0 ? p.t.split(' - ').slice(1).join(' - ') : p.t;
      return p;
    });
  }
  function load() {
    if (idx) return Promise.resolve(idx);
    if (loading) return loading;
    try {
      var c = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < TTL && c.items && c.items.length) { idx = prep(c.items); return Promise.resolve(idx); }
    } catch (e) {}
    var get = function (n) { return fetch(ROOT + 'collections/all?view=gfsindex&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(JSON.parse); };
    loading = get(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(get(n));
      return Promise.all(rest).then(function (pages) {
        var items = first.items;
        pages.forEach(function (pg) { items = items.concat(pg.items); });
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        idx = prep(items);
        return idx;
      });
    }).catch(function () { loading = null; return null; });
    return loading;
  }

  function lev(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var m = [], i, j;
    for (i = 0; i <= b.length; i++) m[i] = [i];
    for (j = 0; j <= a.length; j++) m[0][j] = j;
    for (i = 1; i <= b.length; i++) for (j = 1; j <= a.length; j++) m[i][j] = b[i - 1] === a[j - 1] ? m[i - 1][j - 1] : Math.min(m[i - 1][j - 1] + 1, m[i][j - 1] + 1, m[i - 1][j] + 1);
    return m[b.length][a.length];
  }
  /* Score one typed word against one product. 0 means no match. */
  function wordScore(q, p) {
    var best = 0, fuzzy = false;
    var isNum = /\d/.test(q);
    if (p.stl) {
      if (p.stl === q) best = 120;
      else if (isNum && p.stl.indexOf(q) === 0) best = 90 - Math.min(20, (p.stl.length - q.length) * 3);
      else if (isNum && q.length >= 3 && p.stl.indexOf(q) > 0) best = 40;
    }
    if (p.vn === q || p.vn.split(' ').indexOf(q) >= 0) best = Math.max(best, 30);
    else if (q.length >= 2 && p.vn.indexOf(q) === 0) best = Math.max(best, 22);
    var alts = SYN[q] || [q];
    for (var i = 0; i < p.words.length; i++) {
      var w = p.words[i]; if (!w) continue;
      if (w === q) { best = Math.max(best, 18); continue; }
      if (q.length >= 2 && w.indexOf(q) === 0) best = Math.max(best, 12);
      if (alts !== null && alts.indexOf(w) >= 0) best = Math.max(best, 14);
      if (!best && !isNum && q.length >= 4 && w.length >= 4 && lev(w, q) <= (q.length >= 7 ? 2 : 1)) { best = Math.max(best, 7); fuzzy = true; }
    }
    if (!best && !isNum && q.length >= 4 && lev(p.vn.split(' ')[0], q) <= 1) { best = 8; fuzzy = true; }
    return { s: best, f: fuzzy };
  }
  function tokens(q) {
    var t = norm(q).split(' ').filter(function (x) { return x.length > 1 || /\d/.test(x); });
    var out = [];
    var fams = [];
    t.forEach(function (w, i) {
      if (CODES[w]) { out.push(CODES[w]); return; }
      if (w === 'fit' && t[i - 1] === 'dri') return;
      /* two words from one family ("trucker hat", "tee shirt") count once */
      if (SYN[w]) { if (fams.indexOf(SYN[w]) >= 0) return; fams.push(SYN[w]); }
      /* "t shirt", "long sleeve", "v neck" typed apart */
      if (w === 'shirt' && t[i - 1] === 't') return;
      out.push(w === 't' ? 'tee' : w);
    });
    if (norm(q).indexOf('t shirt') >= 0 && out.indexOf('tee') < 0) out.push('tee');
    return out.filter(function (w) { return ['and', 'the', 'for', 'with', 'of', 'a'].indexOf(w) < 0; });
  }
  function run(q) {
    var toks = tokens(q);
    if (!toks.length || !idx) return { toks: toks, list: [], fuzzy: false };
    var all = [], any = [], fuzzy = false;
    var wantsGender = toks.some(function (t) { return SYN[t] && (SYN[t] === SYN.ladies || SYN[t] === SYN.kids || SYN[t] === SYN.baby || SYN[t] === SYN.girls); });
    idx.forEach(function (p) {
      var sum = 0, hits = 0, fz = false;
      toks.forEach(function (t) { var r = wordScore(t, p); if (r.s) { hits++; sum += r.s; if (r.f) fz = true; } });
      if (!hits) return;
      if (POPULAR.indexOf(p.h) >= 0) sum += 6;
      if (!wantsGender && p.g === 'Unisex') sum += 2;
      var row = { p: p, s: sum, f: fz };
      if (hits === toks.length) all.push(row); else any.push({ p: p, s: sum - (toks.length - hits) * 25, f: fz });
    });
    var list = all.length ? all : any;
    list.sort(function (a, b) { return b.s - a.s || a.p.t.length - b.p.t.length; });
    fuzzy = list.length && list.slice(0, 5).every(function (r) { return r.f; });
    return { toks: toks, list: list, fuzzy: fuzzy, partial: !all.length };
  }
  function mark(text, toks) {
    var out = esc(text);
    toks.forEach(function (t) {
      if (t.length < 2) return;
      var re = new RegExp('(^|[^a-z0-9])(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '[a-z0-9]*)', 'ig');
      out = out.replace(re, function (m, a, b) { return a + '<mark>' + b + '</mark>'; });
    });
    return out;
  }
  function recent() { try { return JSON.parse(localStorage.getItem(RECENT) || '[]'); } catch (e) { return []; } }
  function remember(q) { try { var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); r.unshift(q); localStorage.setItem(RECENT, JSON.stringify(r.slice(0, 5))); } catch (e) {} }
  function sUrl(q) { return SEARCH + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }

  function card(p, toks) {
    var src = img(p, 240);
    return '<a class="gsx-card" data-gsx-item href="' + ROOT + 'products/' + p.h + '">' +
      '<span class="gsx-img">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') + (p.st ? '<em>' + esc(p.st) + '</em>' : '') + '</span>' +
      '<span class="gsx-b"><small>' + esc(p.v) + '</small><b>' + mark(p.name, toks || []) + '</b>' +
      '<span class="gsx-m">' + [p.g && p.g !== 'Unisex' ? (p.g === 'Female' ? 'Women' : p.g === 'Male' ? "Men's fit" : p.g) : 'Unisex', p.nc > 1 ? p.nc + ' colors' : ''].filter(Boolean).join(' · ') + '</span>' +
      '<span class="gsx-p">Blank from <strong>' + money(p.p) + '</strong></span></span></a>';
  }
  function skel(n) { var s = ''; for (var i = 0; i < n; i++) s += '<span class="gsx-card sk"><span class="gsx-img"></span><span class="gsx-b"><i></i><i></i><i></i></span></span>'; return s; }

  function Drop(input, panel, opts) {
    this.i = input; this.el = panel; this.o = opts || {}; this.last = null; this.t = null;
    var self = this;
    panel.classList.add('gsx-drop');
    /* the suggestions mix links, chips and product cards, so the popup is a non-modal dialog, not a listbox */
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Search suggestions');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-haspopup', 'dialog');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    input.addEventListener('focus', function () { load(); self.render(); });
    input.addEventListener('input', function () { clearTimeout(self.t); self.t = setTimeout(function () { self.render(); }, 90); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { self.hide(); return; }
      if (e.key === 'ArrowDown') { var a = self.items()[0]; if (a && !self.el.hidden) { e.preventDefault(); a.focus(); } }
    });
    panel.addEventListener('keydown', function (e) {
      var as = self.items(), k = as.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { if (k < as.length - 1) { e.preventDefault(); as[k + 1].focus(); } }
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); if (k > 0) as[k - 1].focus(); else input.focus(); }
      if (e.key === 'Escape') { self.hide(); input.focus(); }
    });
    panel.addEventListener('click', function (e) {
      var a = e.target.closest('a'); if (!a) return;
      var q = input.value.trim(); if (q) remember(q);
      track('gfs_search_pick', { q: q, href: a.getAttribute('href') });
    });
    var form = input.form;
    if (form) form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); input.focus(); return; }
      remember(q); track('gfs_search', { q: q });
      e.preventDefault(); location.href = sUrl(q);
    });
    document.addEventListener('click', function (e) { if (!panel.contains(e.target) && e.target !== input && !(form && form.contains(e.target))) self.hide(); });
  }
  Drop.prototype.items = function () { return [].slice.call(this.el.querySelectorAll('[data-gsx-item]')); };
  Drop.prototype.hide = function () { this.el.hidden = true; this.i.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('gsx-open'); };
  Drop.prototype.show = function (html) { this.el.innerHTML = html; this.el.hidden = false; this.i.setAttribute('aria-expanded', 'true'); if (this.o.overlay) document.documentElement.classList.add('gsx-open'); };
  Drop.prototype.render = function () {
    var self = this, q = this.i.value.trim();
    if (!idx) { this.show(this.o.compact ? '<div class="gsx gsx-1"><div class="gsx-main"><div class="gsx-grid">' + skel(4) + '</div></div></div>' : '<div class="gsx"><div class="gsx-side"><p class="gsx-h">Loading styles…</p></div><div class="gsx-main"><div class="gsx-grid">' + skel(8) + '</div></div></div>'); load().then(function (x) { if (x) self.render(); else self.fallback(q); }); return; }
    if (!q) return this.idle();
    if (q === this.last && !this.el.hidden) return;
    this.last = q;
    var r = run(q), toks = r.toks, list = r.list;
    var side = '';
    /* Style suggestions */
    var seen = {}, sugg = [];
    list.slice(0, 30).forEach(function (row) { var p = row.p; if (!p.st) return; var k = p.v + ' ' + p.st; if (!seen[k] && sugg.length < 5) { seen[k] = 1; sugg.push(k); } });
    if (r.fuzzy && list[0]) side += '<p class="gsx-dym">Showing matches for <b>' + esc(list[0].p.v) + '</b></p>';
    if (sugg.length) side += '<p class="gsx-h">Styles</p>' + sugg.map(function (s) { return '<a data-gsx-item class="gsx-s" href="' + sUrl(s) + '">' + mark(s, toks) + '</a>'; }).join('');
    /* Categories among matches */
    var cc = {};
    list.forEach(function (row) { row.p.cats.forEach(function (c) { if (CATS[c]) cc[c] = (cc[c] || 0) + 1; }); });
    var cats = Object.keys(cc).sort(function (a, b) { return cc[b] - cc[a]; }).slice(0, 4);
    if (cats.length) side += '<p class="gsx-h">Categories</p>' + cats.map(function (c) { return '<a data-gsx-item class="gsx-s" href="' + ROOT + 'collections/' + c + '"><span>' + esc(CATS[c]) + '</span><em>' + cc[c] + '</em></a>'; }).join('');
    /* Brands among matches */
    var bc = {};
    list.forEach(function (row) { bc[row.p.v] = (bc[row.p.v] || 0) + 1; });
    var brands = Object.keys(bc).sort(function (a, b) { return bc[b] - bc[a]; }).slice(0, 3);
    if (brands.length > 1 || (brands.length === 1 && toks.some(function (t) { return norm(brands[0]).indexOf(t) >= 0; }))) side += '<p class="gsx-h">Brands</p>' + brands.map(function (b) { return '<a data-gsx-item class="gsx-s" href="' + ROOT + 'collections/all?filter.p.vendor=' + encodeURIComponent(b) + '"><span>' + esc(b) + '</span><em>' + bc[b] + '</em></a>'; }).join('');
    /* Help pages */
    var nq = norm(q), pages = PAGES.filter(function (pg) { return toks.some(function (t) { return t.length > 2 && (norm(pg[0]).indexOf(t) >= 0 || pg[2].indexOf(t) >= 0); }); }).slice(0, 3);
    if (pages.length) side += '<p class="gsx-h">Help &amp; services</p>' + pages.map(function (pg) { return '<a data-gsx-item class="gsx-s" href="' + ROOT + pg[1] + '">' + esc(pg[0]) + '</a>'; }).join('');
    var n = this.o.compact ? 4 : 8;
    var main = list.length
      ? '<div class="gsx-head"><p class="gsx-h">' + (r.partial ? 'Closest matches' : 'Products') + '</p><span>' + list.length + (list.length === 1 ? ' style' : ' styles') + '</span></div><div class="gsx-grid">' + list.slice(0, n).map(function (row) { return card(row.p, toks); }).join('') + '</div>'
      : '<div class="gsx-none"><b>No styles match “' + esc(q) + '” yet.</b><span>We carry far more than what’s online. Tell us the brand or style number and we’ll price it.</span><a class="gsx-btn" data-gsx-item href="' + ROOT + 'pages/request-a-quote">Request a quote</a></div>';
    var all = '<a class="gsx-all" data-gsx-item href="' + sUrl(q) + '">See all results for “' + esc(q) + '”<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.4"/></svg></a>';
    this.show('<div class="gsx' + (side ? '' : ' gsx-1') + '">' + (side ? '<div class="gsx-side">' + side + '</div>' : '') + '<div class="gsx-main">' + main + (list.length ? all : '') + '</div></div>');
  };
  Drop.prototype.idle = function () {
    this.last = '';
    var rec = recent();
    var pop = POPULAR.map(function (h) { return idx.filter(function (p) { return p.h === h; })[0]; }).filter(Boolean);
    if (pop.length < 8) idx.forEach(function (p) { if (pop.length < 8 && /^(gildan|bella|comfort|port)/.test(p.vn) && pop.indexOf(p) < 0 && p.g === 'Unisex') pop.push(p); });
    var cc = {};
    idx.forEach(function (p) { p.cats.forEach(function (c) { if (CATS[c]) cc[c] = (cc[c] || 0) + 1; }); });
    var side = '';
    if (rec.length) side += '<p class="gsx-h">Recent</p>' + rec.map(function (q) { return '<a data-gsx-item class="gsx-s gsx-r" href="' + sUrl(q) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7v5l3 2M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' + esc(q) + '</a>'; }).join('');
    side += '<p class="gsx-h">Popular searches</p><div class="gsx-chips">' + IDEAS.map(function (q) { return '<a data-gsx-item href="' + sUrl(q) + '">' + esc(q) + '</a>'; }).join('') + '</div>';
    side += '<p class="gsx-h">Shop by category</p>' + Object.keys(CATS).filter(function (c) { return cc[c]; }).map(function (c) { return '<a data-gsx-item class="gsx-s" href="' + ROOT + 'collections/' + c + '"><span>' + esc(CATS[c]) + '</span><em>' + cc[c] + '</em></a>'; }).join('');
    var n = this.o.compact ? 4 : 8;
    this.show('<div class="gsx"><div class="gsx-side">' + side + '</div><div class="gsx-main"><div class="gsx-head"><p class="gsx-h">Most ordered blanks</p><span>Tap one to start your order</span></div><div class="gsx-grid">' + pop.slice(0, n).map(function (p) { return card(p, []); }).join('') + '</div><a class="gsx-all" data-gsx-item href="' + ROOT + 'collections/all">Browse all ' + idx.length.toLocaleString() + ' styles<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.4"/></svg></a></div></div>');
  };
  /* If the index can't load, use Shopify's own suggestions. */
  Drop.prototype.fallback = function (q) {
    var self = this;
    if (!q) { this.hide(); return; }
    fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last').then(function (r) { return r.json(); }).then(function (d) {
      var ps = d.resources.results.products || [];
      self.show('<div class="gsx gsx-1"><div class="gsx-main"><div class="gsx-grid">' + ps.map(function (p) { return '<a class="gsx-card" data-gsx-item href="' + esc(p.url) + '"><span class="gsx-img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</span><span class="gsx-b"><small>' + esc(p.vendor || '') + '</small><b>' + esc(p.title) + '</b><span class="gsx-p">Blank from <strong>$' + esc(p.price) + '</strong></span></span></a>'; }).join('') + '</div><a class="gsx-all" data-gsx-item href="' + sUrl(q) + '">See all results for “' + esc(q) + '”</a></div></div>');
    }).catch(function () {});
  };

  /* Search results page: put exact style matches first. */
  function bestOnSearchPage() {
    var host = document.querySelector('.gfs-srch .cgrid');
    var q = new URLSearchParams(location.search).get('q');
    if (!host || !q || /filter\./.test(location.search) || /[?&]page=([2-9]|\d\d)/.test(location.search)) return;
    load().then(function () {
      if (!idx) return;
      var r = run(q), top = r.list.filter(function (row) { return row.s >= 60; }).slice(0, 8);
      if (!top.length) return;
      var box = document.createElement('section');
      box.className = 'gsx-best';
      box.innerHTML = '<div class="gsx-head"><p class="gsx-h">Best matches for “' + esc(q) + '”</p><span>' + top.length + (top.length === 1 ? ' style' : ' styles') + '</span></div><div class="gsx-grid">' + top.map(function (row) { return card(row.p, r.toks); }).join('') + '</div>';
      var ctool = document.querySelector('.gfs-srch .ctool');
      (ctool || host).parentNode.insertBefore(box, ctool || host);
    });
  }

  function mic(btn, input) {
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!btn || !SR) return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var r = new SR(); r.lang = document.documentElement.lang || 'en-US'; r.interimResults = false;
      btn.classList.add('on');
      r.onresult = function (ev) { input.value = ev.results[0][0].transcript; input.focus(); input.dispatchEvent(new Event('input')); };
      r.onend = r.onerror = function () { btn.classList.remove('on'); };
      r.start();
    });
  }

  function init() {
    var wrap = document.getElementById('gnavSearch');
    if (wrap) {
      var inp = wrap.querySelector('input[type=search]'), res = document.getElementById('gnav-results');
      if (inp && res) { new Drop(inp, res, { overlay: true }); mic(wrap.querySelector('.mic'), inp); }
      /* Warm the index when the pointer heads for the search bar. */
      wrap.addEventListener('mouseenter', function () { load(); }, { once: true });
    }
    document.querySelectorAll('.gnav-drawer form.msearch').forEach(function (f) {
      var i = f.querySelector('input[type=search]'); if (!i) return;
      var p = document.createElement('div'); p.hidden = true; p.className = 'gsx-mob';
      f.parentNode.insertBefore(p, f.nextSibling);
      new Drop(i, p, { compact: true });
    });
    bestOnSearchPage();
    /* Warm the index in the background unless the visitor is saving data. */
    var saver = navigator.connection && navigator.connection.saveData;
    if (!saver) (window.requestIdleCallback || function (f) { setTimeout(f, 2500); })(function () { load(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.GFSSearch = { load: load, run: function (q) { return run(q).list.slice(0, 10).map(function (r) { return [r.s, r.p.t]; }); } };
})();
